import { buildQuestionExplosion } from '../features/ttqib/ttqQuestionExplosionEngine';

export type KpExplosionSegment = {
  objectId: string;
  text: string;
};

export type KpExplosionSubGroup = {
  order: number;
  segments: KpExplosionSegment[];
};

export type KpQaExplosionModel = {
  mainSegments: KpExplosionSegment[];
  subGroups: KpExplosionSubGroup[];
};

function explodeBlock(
  particleId: string,
  text: string,
  indexOffset: number,
  idPrefix: 'seg' | 'aseg',
): { segments: KpExplosionSegment[]; nextOffset: number } {
  const explosion = buildQuestionExplosion(String(text || '').trim());
  const segments = explosion.segments.map((segment, index) => ({
    objectId: `kp:${idPrefix}:${particleId}:${indexOffset + index}`,
    text: segment.text,
  }));
  return { segments, nextOffset: indexOffset + segments.length };
}

/** 将题干/答案 display 拆成与品题卡一致的内联可选段 */
export function buildKpQaExplosionModel(
  particleId: string,
  display: { main: string; items: string[] },
  kind: 'question' | 'answer' = 'question',
): KpQaExplosionModel {
  const idPrefix = kind === 'answer' ? 'aseg' : 'seg';
  let offset = 0;
  const mainText = String(display.main || '').trim();
  const main = mainText
    ? explodeBlock(particleId, mainText, offset, idPrefix)
    : { segments: [] as KpExplosionSegment[], nextOffset: 0 };
  offset = main.nextOffset;

  const subGroups: KpExplosionSubGroup[] = [];
  display.items.forEach((item, index) => {
    const text = String(item || '').trim();
    if (!text) return;
    const block = explodeBlock(particleId, text, offset, idPrefix);
    offset = block.nextOffset;
    if (block.segments.length) {
      subGroups.push({ order: index + 1, segments: block.segments });
    }
  });

  return {
    mainSegments: main.segments,
    subGroups,
  };
}
